import './notFoundPage.scss';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { ThemeProvider } from '@mui/material/styles';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import ErrorImg from '../../assets/hero-error-with-smoke.svg';
import useThemeStore from '../../store/themeStore/useThemeStore';
import { locator } from '../../testing/e2e-locator/locator';

export function Component(): ReactNode {
  const { createTheme } = useThemeStore();
  const theme = createTheme();

  const { t } = useTranslation();

  const redirectToDashboard = (): void => {
    window.location.assign('/dashboard/garage');
  };

  return (
    <div className="not-found-page">
      <ThemeProvider theme={theme}>
        <Box sx={theme.pageLayout}>
          <header data-testid={locator.pages.notFound.header.root} />

          <main data-testid={locator.pages.notFound.main.root}>
            <span style={{ marginBottom: '1rem' }}>
              <img alt={t('imageAlts.heroErrorWithSmoke')} src={ErrorImg} />
            </span>

            <span style={{ marginBottom: '3rem' }}>
              <h1 data-testid={locator.pages.notFound.main.h1}>
                {t('NotFoundPage.title')}
              </h1>
              <h2 data-testid={locator.pages.notFound.main.h2}>
                {t('NotFoundPage.subtitle')}
              </h2>
            </span>

            <span>
              <Button
                data-testid={locator.pages.notFound.main.returnHomeButton}
                type="button"
                variant="contained"
                onClick={redirectToDashboard}
              >
                {t('NotFoundPage.returnHome')}
              </Button>
            </span>
          </main>
        </Box>
      </ThemeProvider>
    </div>
  );
}

Component.displayName = 'NotFoundPage';
